import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./Redux/store";

// Suppress benign observer errors that some libraries surface as a blocking
// dev-mode error overlay in preview:
//  - "ResizeObserver loop ..." from Radix UI
//  - Google Maps' "IntersectionObserver ... not of type 'Element'" which the
//    Maps JS API throws asynchronously when its tiles/auth overlay mounts.
//    It does not affect app functionality (the map area degrades on its own).
const isBenignObserverError = (msg) =>
  !!msg && (
    msg.includes('ResizeObserver loop') ||
    (msg.includes('IntersectionObserver') && (msg.includes('parameter 1') || msg.includes('Element')))
  );

window.addEventListener('error', (e) => {
  if (isBenignObserverError(e?.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

window.addEventListener('unhandledrejection', (e) => {
  const msg = e?.reason?.message || String(e?.reason || '');
  if (isBenignObserverError(msg)) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
      <App />
    </Provider>
);